export const viewsEn = {
  playersSelection: {
    title: 'Players',
    info: 'Please select a competition to see their players',
    buttonCompetition: 'See players'
  },
  playersIndex:{
    title: 'Players',
    subtitle: 'Players from the competition',
    info: 'Please select a competition to see their players',
    searchLabel: 'Search player',
    tableHeadText: {
      name: 'Name',
      fullname: 'Fullname',
      country: 'Country',
      height: 'Height',
      weight: 'Weight',
      role: 'Role',
      team: 'Team'
    },
    cardstableText: 'Change visualization',
    confirmationDialog: {
      bulk: {
        title: 'Confirmation',
        description: 'Please confirm bulk action.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
  },
  matchesSelection: {
    title: 'Matches',
    info: 'Please select a competition to see their matches',
    buttonCompetition: 'See matches'
  },
  matchesIndex:{
    title: 'Matches',
    subtitle: 'Matches from the competition',
    info: 'Please select a competition to see their matches',
    tableHeads: {
      matchday: 'Nº Matchday',
      hometeam: 'Home Team',
      score: 'Score',
      awayteam: 'Away Team',
      startdate: 'Start date',
      type: 'Type',
      status: 'Status',
      load: 'Load'
    },
    filter: {
      matchday: 'Nº Matchday',
      team: 'Team',
      homeTeam: 'Home Team',
      awayTeam:'Away Team',
      status: 'Status'
    },
    confirmationDialog: {
      bulk: {
        title: 'Confirmation',
        description: 'Please confirm the bulk action.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
  },
  matchsetsIndex:{
    title: 'Matchsets',
    filter: {
      name: 'Search by name',
      sport: 'Sport',
      status: 'Status'
    },
    tableHeadText: {
      public: 'Public',
      name: 'Name',
      sport: 'Sport',
      status: 'Status',
      createdBy: 'Created by',
      startdate: 'Start date',
      enddate: 'End date',
      options: 'Options',
      load: 'Load'
    },
    actions:{
      open:'Open',
      close:'Close'
    },
    buttonInfo: 'See Info',
    confirmationDialog: {
      reload: {
        title: 'Confirmation',
        description: 'Please confirm the reload action.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
      public: {
        title: 'Confirmation',
        description: 'Please confirm the public change.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
      actions: {
        title: 'Confirmation',
        description: 'Please confirm the action.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
  },
  contestsIndex: {
    title: 'Contests',
    filter: {
      name: 'Search by Name',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status'
    },
    tableHeadText: {
      name: 'Name',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status',
      sport: 'Sport',
      options: 'Opciones'
    },
    actions:{
      open: 'Open',
      close: 'Close',
      finish: 'Finish',
      score: 'Score',
      winners: 'Fix winners',
      abandom: 'Abandom',
      suspen: 'Suspen',
    },
    confirmationDialog: {
      actions: {
        title: 'Confirmation',
        description: 'Please confirm the action.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
  },
  teamsSelection: {
    title: 'Teams',
    info: 'Please select a competition to see their teams',
    buttonTeams: 'See teams'
  },
  teamsIndex:{
    title: 'Teams',
    subtitle:'Teams from the competition',
    info: 'Please select a competition to see their teams',
    filter:{
      team: 'Team',
      search: 'Search Team',
    },
    tableHeadText: {
      name: 'Name',
      short: 'Abbreviation',
      country: 'Country',
      venue: 'Venue',
      players: 'Players',
      button: 'See players',
      playerTitle: 'Players from ',
      playerName: 'Name',
      playerRole: 'Role'
    },
    cardstableText: 'Change visualization',
    confirmationDialog: {
      bulk: {
        title: 'Confirmation',
        description: 'Please confirm bulk action.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
  },
  competitionsIndex:{
    title: 'Competitions',
    titleAll: 'All competitions',
    buttonMatches: 'See Matches',
    buttonTeams: 'See Teams',
    tableHeadText: {
      name: 'Name',
      sport: 'Sport',
      status: 'Status',
      country: 'Country',
      season: 'Season',
    },
    confirmationDialog: {
      status: {
        title: 'Confirmation',
        description: 'Please confirm the status change.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
  },
  networksIndex:{
    title: 'Networks',
    tableHeadText: {
      name: 'Name',
      fee: 'Fee',
      organizer: 'Organizer',
      jurisdiction: 'Jurisdiction',
      disabled: 'Disabled'
    },
    status:{
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
    button: 'See Info',
    confirmationDialog: {
      status: {
        title: 'Confirmation',
        description: 'Please confirm the status change.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
  },
  providersIndex:{
    title: 'Providers',
    tableHeadText: {
      name: 'Name',
      key: 'Key',
      status:'Status'
    },
    confirmationDialog: {
      status: {
        title: 'Confirmation',
        description: 'Please confirm the status change.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
    dialog: {
      iplist: {
        button: 'IPS\'s list',
        title: 'IPS\'s list: ',
      }
    },
    status:{
      enabled:'Enabled',
      disabled:'Disabled'
    },
    button:'See Info'
  },
  operatorsIndex:{
    title:'Operators',
    tableHeadText: {
      name: 'Name',
      code: 'Code',
      connector:'Connector',
      jurisdiction:'Jurisdiction',
      host:'Host',
      status:'Status'
    },
    confirmationDialog: {
      status: {
        title: 'Confirmation',
        description: 'Please confirm the status change.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
    dialog: {
      details: {
        button: 'Resume',
        title: 'Resume: ',
        labels: {
          name: 'Name',
          id: 'Code',
          connector: 'Connector',
          key: 'Key',
          connectorId: 'ConnectorId',
          connectorKey: 'ConnectorKey',
          jurisdiction: 'Jurisdiction',
          status: 'Status',
          casinoApi: 'CasinoApi',
          sportsApi: 'SportsApi',
          bonusApi: 'BonusApi',
          disabled: 'Disabled',
          retail: 'Retail',
          invoice: 'Invoice',
          url: {
            lobby: 'Lobby',
            cashier: 'Cashier',
            virtualsports: 'Virtualsports',
            sportsbook: 'Sportsbook',
          },
          cfg: {
            cl: 'cl',
            oi: 'oi',
            raf: 'raf',
            rafpct: 'rafpct',
          },
          sms: {
            enabled: 'Enabled',
            origin: 'Origin',
            user: 'User',
          },
        },
      },
      iplist: {
        button: 'IPS\'s list',
        title: 'IPS\'s list: ',
        // labels: {
        //   name: 'Name',
        //   id: 'Code',
        //   connector: 'Connector',
        //   key: 'Key',
        //   host: 'Host',
        // },
      },
      providers: {
        expandButton: 'Providers',
      },
    },
    status:{
      enabled:'Enabled',
      disabled:'Disabled'
    },
    key:'Key',
    licenses:'Licenses',
    button: 'View info',
    emptyProviders: 'This operator doesn\'t have providers',
  },
  usersIndex:{
    title:'Users',
    filter: {
      name: 'Filters',
      operator: 'Operator',
      start: 'From',
      end: 'To',
      send: 'Filter',
    },
    tableHeadText: {
      operator: 'Operator',
      id: 'ID',
      username:'Username',
      registrationDate:'Registration date',
      lastTransaction:'Last transaction date',
      currency:'Currency'
    },
    button: 'View info',
  },
  gamesIndex:{
    title:'Games',
    filter:{
      provider:'Provider',
      jurisdiction: 'Jurisdiction',
      license: 'License',
    },
    tableHeadText: {
      name: 'Name',
      alias: 'Alias',
      type:'Type',
      status:'Status',
      provider:'Provider',
      key:'Launch ID'
    },
    confirmationDialog: {
      status: {
        title: 'Confirmation',
        description: 'Are you sure you want to disable this game?.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
    status:{
      enabled:'Enabled',
      disabled:'Disabled'
    },
    button: 'View info',
  },
  roundsIndex:{
    title:'Rounds',
    filter: {
      name: 'Filters',
      operator: 'Operator',
      provider: 'Provider',
      game: 'Game',
      start: 'From',
      end: 'To',
      send: 'Filter',
    },
    tableHeadText: {
      roundId: 'Round ID',
      operator: 'Operator',
      provider:'Provider',
      game:'Game',
      moneyIn:'Money in',
      moneyOut:'Money out',
      user:'User',
      status:'Status',
      start:'Start'
    },
    confirmationDialog: {
      status: {
        title: 'Confirmation',
        description: 'Please confirm the status change.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
    status:{
      enabled:'Enabled',
      disabled:'Disabled'
    },
    button: 'View info',
  },
  adminIndex:{
    title:'Administrators',
    tableHeadText: {
      name: 'Name',
      email: 'Email',
      rol:'Rol'
    },
    button: 'View info',
  },
  dashboardIndex: {
    dashboard:'Dashboard',
    economicSection: 'Economic Section',
    usersSection: 'Users Section',
    gamesSection: 'Games Section',
    playersSection: 'Players Section',
    providersSection: 'Providers Section',
    operatorsSection: 'Operators Section',
    chars:{
      revenue:'Revenue',
      moneinout:'Money In/Out',
      registeredUsers:'Registered Users'
    },
    dateToggle:{
      week:'7 days',
      month:'30 days',
      year:'1 year',
      twoyears:'2 years',
      custom:'Custom'
    },
    sections: {
      topRevenue: 'Top Revenue',
      topLoss: 'Top Loss',
      topWinners: 'Top Winners',
      topLosers: 'Top Losers'
    },
  },
  categoriesIndex:{
    title: 'Categories',
    tableHead: {
      name: 'Name',
      sport: 'Sport',
      country: 'Country',
    },
  },
  rtpIndex:{
    title: 'RTP',
    filter: {
      name: 'Filters',
      operator: 'Operator',
      month: 'Check month',
      send: 'Filter',
    },
    tableHead: {
      name: 'Provider',
      game: 'Game',
      teoricRtp: 'Teoric RTP',
      desktopRtp: 'RTP Desktop',
      mobileRtp: 'RTP Mobile',
    },
    button: {
      downloadcsv: 'Download CSV',
    }
  },
  freespinsIndex: {
    title: 'Freespins',
    confirmationDialog: {
      status: {
        title: 'Confirmation',
        description: 'Please confirm the status change.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
  },
  lobbyIndex: {
    title: 'Lobby',
    tableHead: {
      operator: 'Operator',
      name: 'Name',
      ncategories: 'Number of categories',
      ngames: 'Number of games',
    },
  },
  freeroundsIndex: {
    title: 'Freerounds',
    confirmationDialog: {
      status: {
        title: 'Confirmation',
        description: 'Please confirm the status change.',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
  },
};
